import { combineReducers } from '@reduxjs/toolkit'

import { calcReducer } from './calcBot/slice'
import { botApi } from './rtkApi/botApi'

export const rootReducer: any = combineReducers({
  calc: calcReducer,
  [botApi.reducerPath]: botApi.reducer,
})
